import { atom } from "jotai";

export const outlineAtom = atom<string>("");
outlineAtom.debugLabel = "outlineAtom";
